import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Timeline = ({
  index,
  data,
  labelColor,
  lineColor = '#29A645',
  color = '#29A645',
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isLeft = index % 2 === 0;
  const textAlign = isLeft ? 'right' : 'left';
  const iconSize = isMobile ? 'small' : 'large';

  const eventTime = data["Event Time"]?.trim()
    ? new Date(data["Event Time"].trim()).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
    : null;

  const dynamicData = Object.entries(data).filter(
    ([key]) => key !== 'Event Time' && key !== 'Event Name'
  );

  const card = (
    <div className={`timeline-card timeline-card-${color}`}>
      <div
        className={`timeline-label timeline-label-${labelColor}`}
        style={{ textAlign }}
        title={data["Event Name"]?.trim()}
      >
        {data["Event Name"]?.trim()}
      </div>
      <div className="timeline-card-content">
        {dynamicData.map(([key, value], i) => (
          <div key={i} className="timeline-dynamic-row">
            <span className="timeline-key" title={key}>{key}:</span>
            <span
              className="timeline-value"
              title={value}
            >
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="timeline-container">
      <div
        className="timeline-line"
        style={{ height: "115%", background: lineColor }}
      />
      <div className="timeline-grid">
        {/* Left column */}
        <div className="timeline-column">
          {isLeft && card}
          {!isLeft && eventTime && (
            <div
              className={`timeline-event-time timeline-event-time-${labelColor}`}
              style={{ textAlign: 'right' }}
            >
              {eventTime}
            </div>
          )}
        </div>
        {/* Icon */}
        <div className="timeline-icon-container">
          <div
            className={`timeline-icon timeline-icon-${iconSize}`}
            style={{
              backgroundColor: color,
              boxShadow: `0 0 0 0.1em ${lineColor} inset`,
            }}
          >
            <i className="icon-event" />
          </div>
        </div>
        {/* Right column */}
        <div className="timeline-column">
          {!isLeft && card}
          {isLeft && eventTime && (
            <div
              className={`timeline-event-time timeline-event-time-${labelColor}`}
              style={{ textAlign: 'left' }}
            >
              {eventTime}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Timeline.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  labelColor: PropTypes.string,
  lineColor: PropTypes.string,
  color: PropTypes.string,
};

export default memo(Timeline);



